<template>
    <v-dialog
        v-model="showDialog"
        width="600"
    >
        <v-card>
            <v-form
                ref="form"
                @submit.prevent="submitForm"
            >
                <v-card-title
                    style="background-color: #009688; color: white;"
                >
                    Delete Rate: &nbsp;<v-chip>{{ data && data.DIA_T ? data.DIA_T : '' }}</v-chip>
                </v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model="deleteData.DIA_T"
                        disabled
                        label="Diagnostic"
                        color="teal"
                        clearable
                    />
                    <v-text-field
                        v-model="deleteData.PHP_N"
                        disabled
                        label="Price"
                        color="teal"
                        clearable
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="teal darken-1"
                        outlined
                        width="120"
                        @click="showDialog = false"
                    >
                        <v-icon>{{ mdiClose }}</v-icon>
                        close
                    </v-btn>
                    <v-btn
                        color="teal darken-1"
                        width="120"
                        style="color: white;"
                        type="submit"
                    >
                        <v-icon>{{ mdiTrashCan }}</v-icon>
                        delete
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import {
    mdiClose,
    mdiTrashCan
} from '@mdi/js'

export default {
    props: ['show', 'data'],
    data: ()=>({
        mdiClose,
        mdiTrashCan,
        deleteData: {
            ID: null,
            MSU_C: null,
            DIA_T: null,
            PHP_N: null
        },
        isValidPHPN: value => {
            if (value === '' || value === null) return true
            const regex = /^(0|[1-9]\d*)(\.\d+)?$/
            return regex.test(value) || 'Enter a non-negative number'
        },
        requiredField: [v=>!!v||'This field is required']
    }),
    computed: {
        showDialog: {
            get() {
                this.initData()
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        }
    },
    methods: {
        ...mapActions(['deleteMsuRates', 'suggestAcuDiagnostics']),
        submitForm() {
            if (this.$refs && this.$refs.form.validate()) {
                this.deleteMsuRates(this.deleteData).then(() => this.suggestAcuDiagnostics())
            }
        },
        initData() {
            if (this.$refs && this.$refs.form) {
                this.$refs.form.resetValidation()
            }
            this.deleteData = structuredClone(this.data)
        }
    }
}
</script>
